import { APY_RANGE_KEY } from '@/constants/state'
import { useMixpanel } from '@/context/mixpanel'
import { VALID_APY_RANGES } from '@/context/settings'
import { useVaultsSearchState } from '@/hooks/useVaultsSearchState'
import type { VaultApyRange } from '@/types/apy'
import { getApyRangeCopy } from '@/utils/apy'
import { cn } from '@/utils/cn'
import { useCallback } from 'react'
import { RadioGroup, type RadioProps, RadioTile } from '../common/radio'

export function ApyRangeFilter({ className, ...props }: RadioProps) {
  const { apyRange, updateSearchState } = useVaultsSearchState()
  const { trackEvent } = useMixpanel()

  const handleApyRange = useCallback(
    (apyRange: VaultApyRange) => {
      updateSearchState([APY_RANGE_KEY, apyRange])
      trackEvent('Filter used', {
        Filter: 'APY range',
        Value: apyRange,
      })
    },
    [trackEvent]
  )

  return (
    <RadioGroup value={apyRange} onValueChange={handleApyRange} className={cn('rounded-xl', className)} {...props}>
      {VALID_APY_RANGES.map((apyRange) => (
        <RadioTile key={apyRange} id={apyRange} value={apyRange} className="rounded-lg">
          {getApyRangeCopy(apyRange).full}
        </RadioTile>
      ))}
    </RadioGroup>
  )
}
